import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import Header from '../components/Header';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header user={null} setUser={() => {}} />
      
      <div className="flex items-center justify-center px-6 py-24">
        <div className="max-w-md w-full bg-surface rounded-2xl p-8 border border-border text-center" data-testid="payment-cancel-page">
          <XCircle className="w-16 h-16 text-error mx-auto mb-6" />
          <h2 className="font-heading text-2xl font-bold text-text-primary mb-3">Payment Cancelled</h2>
          <p className="text-text-secondary mb-8">
            Your payment was cancelled. No charges were made to your account.
          </p>
          <div className="flex flex-col gap-3">
            <button onClick={() => navigate('/')} className="btn-primary w-full">
              Search Again
            </button>
            <button onClick={() => navigate('/dashboard/customer')} className="btn-secondary w-full">
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
